import { cloneElement } from 'react'

import styled from 'styled-components'

import { ButtonAsync } from '@subaio/components'

import { helpers } from 'styles'

const IconWrapper = styled.div`
	display: flex;
	justify-content: space-around;
	align-items: center;
	margin-top: 1px;
`

type Props = {
	fullWidth?: boolean
	icon: React.JSX.Element
	removeAlignment?: boolean
	size?: number
	type?: keyof Omit<typeof helpers.color, 'status' | 'input' | 'button'>
}

export const Icon = styled(ButtonAsync).attrs<Props>(({ icon, size = 28, removeAlignment }) => ({
	label:
		icon && removeAlignment ? cloneElement(icon, { size }) : <IconWrapper>{cloneElement(icon, { size })}</IconWrapper>,
}))<Props>`
	color: ${({ type = 'primary' }) => helpers.color[type]};
	background-color: transparent;
	min-width: initial;
	width: 32px;
	height: 28px;
	padding: 0;
	margin: 0 4px;
	border-radius: 4px;
	transition: color 0.2s, background-color 0.2s, border-color 0.2s;
	isolation: isolate;

	&:is(:focus-visible, :hover) {
		background-color: ${helpers.color.primaryHover};
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}

	&:after {
		content: '';
		display: block;
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		pointer-events: none;
		background-image: radial-gradient(circle, ${({ type = 'primary' }) => helpers.color[type]} 16%, transparent 16.01%);
		background-repeat: no-repeat;
		background-position: 50%;
		transform: scale(10, 10);
		opacity: 0;
		transition: transform 0.7s, opacity 0.9s;
	}

	&:active:after {
		transform: scale(0, 0);
		opacity: 0.2;
		transition: 0s;
	}

	&:disabled:after {
		opacity: 0;
	}

	&:disabled {
		color: ${helpers.color.disabled};
		background-color: transparent;
	}
`
